import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { Subscription } from 'rxjs';
import { NotificationsService, Notification } from './service/notifications.service';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css',
  animations: [
    trigger('notificationAnimation', [
      state('void', style({
        transform: 'translateX(100%)',
        opacity: 0
      })),
      state('visible', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('void => visible', [
        animate('300ms cubic-bezier(0.68, -0.55, 0.27, 1.55)')
      ]),
      transition('visible => void', [
        animate('200ms cubic-bezier(0.68, -0.55, 0.27, 1.55)', style({
          transform: 'translateX(105%)',
          opacity: 0
        }))
      ])
    ]),
    trigger('progressAnimation', [
      state('start', style({ width: '100%' })),
      state('end', style({ width: '0%' })),
      transition('start => end', [
        animate('{{duration}}ms linear')
      ], { params: { duration: 5000 }})
    ])
  ]
})
export class NotificationsComponent implements OnInit, OnDestroy {
  notifications: Notification[] = [];
  private subscription: Subscription | null = null;

  constructor(private notificationsService: NotificationsService) {}

  ngOnInit(): void {
    this.subscription = this.notificationsService.getNotifications()
      .subscribe(notifications => {
        this.notifications = notifications;
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  closeNotification(id: string): void {
    this.notificationsService.removeNotification(id);
  }

  getIconClass(type: string): string {
    switch(type) {
      case 'success': return 'bg-green-500';
      case 'error': return 'bg-red-500';
      case 'warning': return 'bg-yellow-500';
      case 'info': return 'bg-blue-500';
      default: return 'bg-gray-500';
    }
  }

  getNotificationClass(type: string): string {
    switch(type) {
      case 'success': return 'border-l-4 border-green-500 bg-green-50 dark:bg-green-900/60 dark:border-green-400';
      case 'error': return 'border-l-4 border-red-500 bg-red-50 dark:bg-red-900/60 dark:border-red-400';
      case 'warning': return 'border-l-4 border-yellow-500 bg-yellow-50 dark:bg-yellow-900/60 dark:border-yellow-400';
      case 'info': return 'border-l-4 border-blue-500 bg-blue-50 dark:bg-blue-900/60 dark:border-blue-400';
      default: return 'border-l-4 border-gray-500 bg-gray-50 dark:bg-gray-900/60 dark:border-gray-400';
    }
  }

  getIconContent(type: string): string {
    switch(type) {
      case 'success': return '✓';
      case 'error': return '✕';
      case 'warning': return '!';
      case 'info': return 'i';
      default: return '•';
    }
  }
}
